var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('copy-link-button');
import { breakpoints } from '@shapeable/theme';
import { IconBubble } from './icon-bubble';
import { useCopyToClipboard } from '../hooks/use-copy-to-clipboard';
import { useState } from 'react';
import { LinkIconGlyph, TickIconGlyph } from '@shapeable/icons';
export var CopyLinkButtonDefaultProps = {
  onCopy: function (url) {},
  onCopyDone: function (url) {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
var BubbleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.1);\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubble: styled(IconBubble)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles)
};
export var CopyLinkButton = function (props) {
  var className = props.className,
    url = props.url,
    title = props.title,
    onCopy = props.onCopy,
    onCopyDone = props.onCopyDone,
    color = props.color,
    hoverColor = props.hoverColor,
    iconColor = props.iconColor;
  var _a = __read(useCopyToClipboard(url), 2),
    copied = _a[0],
    copy = _a[1];
  var _b = __read(useState(false), 2),
    tick = _b[0],
    setTick = _b[1];
  var onClick = function () {
    copy();
    setTick(true);
    onCopy(url);
    setTimeout(function () {
      setTick(false);
      onCopyDone(url);
    }, 2000);
  };
  return React.createElement(My.Container, {
    title: title,
    role: "button",
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(My.Bubble, {
    hoverColor: hoverColor,
    iconColor: iconColor,
    color: color,
    icon: tick ? React.createElement(TickIconGlyph, null) : React.createElement(LinkIconGlyph, null)
  }));
};
CopyLinkButton.defaultProps = CopyLinkButtonDefaultProps;
CopyLinkButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;